var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function CursorsHandGrabbingIconInner(props) {
    return (React.createElement("svg", __assign({ width: 20, height: 21, viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { filter: "url(#filter0_d_4489_22182)" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 7H17V12H16V14H15V17H7V15H6V14H5H4V13H3V9H4V8H5V6H6V5H7H9V4H11V5H12H14V6H16V7Z", fill: "" })),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15V16H14V14H15V12H16V7H15V8H14V6H13H12V7H11V5H9V7H8V6H6V10H5V9H4V12H5V13H6V14H7V15H8ZM10 10H9V13H10V10ZM11 10H12V13H11V10ZM14 11H13V13H14V11Z", fill: "white" }),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_4489_22182", x: 0, y: 2, width: 20, height: 19, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 1 }),
                React.createElement("feGaussianBlur", { stdDeviation: 1.5 }),
                React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }),
                React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_4489_22182" }),
                React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_4489_22182", result: "shape" })))));
}
export var CursorsHandGrabbingIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: CursorsHandGrabbingIconInner }, props))); };
//# sourceMappingURL=CursorsHandGrabbingIcon.js.map